import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AnimationOptions, LottieModule } from 'ngx-lottie';
import { injectDefaultEmptyStateVisualSource } from '../models/empty-state-tokens';
import { EmptyStateVisualSource, visualSourcesDictionary } from '../models/empty-state-visual-sources';
import { CommonModule, NgIf } from '@angular/common';
import { SpacingDirective } from '@panaya/ui';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'empty-state-visual',
    standalone: true,
    imports: [CommonModule, LottieModule, NgIf, SpacingDirective],
    templateUrl: './empty-state-visual.component.html',
    styleUrls: ['./empty-state-visual.component.scss'],
    providers: []
})
export class EmptyStateVisualComponent implements OnChanges {
    @Input() public visualSource?: EmptyStateVisualSource;

    private readonly defaultSource = injectDefaultEmptyStateVisualSource();

    protected isJson = false;
    protected visualSourcePath!: string;
    protected options: AnimationOptions = {
        path: this.defaultSource,
        autoplay: true,
        loop: true
    };

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['visualSource']) {
            this.setVisualSource(changes['visualSource'].currentValue as EmptyStateVisualSource);
            this.setIsJson();
        }
    }

    private setVisualSource(visualSourcePath: EmptyStateVisualSource): void {
        this.visualSourcePath = visualSourcesDictionary[visualSourcePath ?? this.defaultSource];

        this.options = {
            ...this.options,
            path: this.visualSourcePath
        };
    }

    private setIsJson(): void {
        this.isJson = this.visualSourcePath.endsWith('.json');
    }
}
